import Component from '@glimmer/component';
import { service } from '@ember/service';
import { LinkTo } from '@ember/routing';
import t from 'ember-intl/helpers/t';
import type { IntlService } from 'ember-intl';
import { VStack } from 'tio-ui/components/layout';
import Heading from 'tio-ui/components/heading';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import LoanPlansSection from 'tio-common/components/strategy-finder-0726/loan-plans-section';
import { parseResultSections } from 'tio-common/utils/strategy-finder-0726';

interface IdrDashboard0726ResultsTableSignature {
  Args: {
    recommendation: RecommendationModel;
  };
  Element: HTMLElement;
}

export default class IdrDashboard0726ResultsTableComponent extends Component<IdrDashboard0726ResultsTableSignature> {
  @service declare intl: IntlService;

  // The stored recommendation is already filtered to current + income-driven
  // plans by the backend (see tio-api SortPlansEstimatorFilter), so just parse it.
  get sections() {
    return parseResultSections(
      this.args.recommendation.calculationInput,
      this.args.recommendation.calculationOutput
    );
  }

  <template>
    <VStack data-test-idr-0726-results ...attributes>
      <Heading @level={{2}} @role="section-title">
        {{t "strategy_finder_0726.results.title"}}
      </Heading>
      {{#if @recommendation.hasErrorsInCalcs}}
        <div class="m-2" data-test-idr-0726-results-error>
          {{t "strategy_finder_0726.results.error_in_calcs"}}
          <LinkTo @route="authenticated.idr.dashboard.questionnaire" class="app-text-link">
            {{t "strategy_finder_0726.results.error_link_text"}}
          </LinkTo>
        </div>
      {{else}}
        {{#each this.sections as |section|}}
          <LoanPlansSection @section={{section}} @analysisDate={{@recommendation.createdAt}} />
        {{/each}}
      {{/if}}
    </VStack>
  </template>
}
